import cx from "classnames";
import React from "react";
import { connect } from "react-redux";

import BlockedBazaarMessage from "@/mk2/apps/bazaar/components/BlockedBazaarMessage";
import SellerDetails from "@/mk2/apps/bazaar/components/SellerDetails";
import SellerLineMenu from "@/mk2/apps/bazaar/components/SellerLineMenu";
import SellerStatusMessage from "@/mk2/apps/bazaar/components/SellerStatusMessage";
import { SellerEntity } from "@/mk2/apps/bazaar/schemas";
import { AppState, getRequestPermissions, getRequestUser } from "@/mk2/reducers";
import { HistoryLocationWithState, RoutePathPattern } from "@/mk2/services/browserHistory";
import { canManageBazaar, isAuthenticatedAs } from "@/mk/bazaar/common/userUtils";

import styles from "./HerBazaarHeader.mscss";

interface OwnProps {
    className?: string;
    seller: SellerEntity;
    routePathPattern: RoutePathPattern;
    location: HistoryLocationWithState;
}

interface StateProps {
    isSeller?: boolean;
    isAdmin?: boolean;
}

type Props = OwnProps & StateProps;

const HerBazaarHeader: React.FunctionComponent<Props> = ({
    className,
    seller,
    routePathPattern,
    isSeller = false,
    isAdmin = false,
    location,
}) => (
    <div className={cx(styles.HerBazaarHeader, className)}>
        {seller.hasBlockedBazaar && (
            <BlockedBazaarMessage
                className={styles.HerBazaarHeader__blocked}
                isSeller={false}
                selfBlocked={seller.user?.isBlockedSelf}
                username={seller.username}
            />
        )}
        <SellerDetails seller={seller} isSeller={isSeller} isAdmin={isAdmin} location={location} />
        {(!seller.hasBlockedBazaar || isSeller || isAdmin) && (
            <SellerStatusMessage
                className={styles.HerBazaarHeader__statusMessage}
                seller={seller}
            />
        )}
        <SellerLineMenu
            className={styles.HerBazaarHeader__lineMenu}
            seller={seller}
            routePathPattern={routePathPattern}
        />
    </div>
);

HerBazaarHeader.displayName = "HerBazaarHeader";

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const requestUser = getRequestUser(state);
    const requestUserPermissions = getRequestPermissions(state);

    const isSeller = isAuthenticatedAs(requestUser, ownProps.seller.user);
    const isAdmin = canManageBazaar(requestUserPermissions);

    return {
        isSeller,
        isAdmin,
    };
}

export default connect(mapStateToProps, null)(HerBazaarHeader);
